import { Outlet } from 'react-router-dom';
import Navbar from './../components/Navbar/Navbar';
import { useAppSelector } from '../core/hooks/hooks';
import { getLoader } from '../core/store/slices/loaderSlice';
import Spinner from '../components/Spinner/Spinner';
import { socketConnection } from '../utils/api/socket';
import { useAppDispatch } from './../core/hooks/hooks';
import { resetDialogue, setDialogue } from './../core/store/slices/dialogueSlice';
import successIcon from './../../src/assets/images/Winner.svg';
import { useTranslation } from 'react-i18next';

export const echo = socketConnection();

const RootLayout = () => {
	const loader = useAppSelector(getLoader);
	const dispatch = useAppDispatch();
	const { t } = useTranslation();
	const user = localStorage.getItem('user');
	let user_slug = '';
	if (user) {
		user_slug = JSON.parse(user).slug;
	}
	echo.channel(`${process.env.REACT_APP_TENANT_NAME}.general.${user_slug}`).listen('.tournament-won', (e: any) => {
		dispatch(
			setDialogue({
				show: true,
				type: 'Success',
				acceptColor: '#01ABC1',
				textColor: '#01ABC1',
				image: successIcon,
				hasAction: false,
				acceptLabel: <div>{t('Continue')}</div>,
				title: `${t('winnerToaster')}`,
				text: `${t('winnerToaster-text', { team: e.team.name, tournament: e.tournament.name, type: e.type })}`,
				onAccept: () => {
					dispatch(resetDialogue());
				},
			}),
		);
	});

	echo.channel(`${process.env.REACT_APP_TENANT_NAME}.general.${user_slug}`).listen('.cup-won', (e: any) => {
		dispatch(
			setDialogue({
				show: true,
				type: 'Success',
				acceptColor: '#01ABC1',
				textColor: '#01ABC1',
				image: successIcon,
				hasAction: false,
				acceptLabel: <div>{t('Continue')}</div>,
				title: `${t('winnerToaster')}`,
				text: `${t('winnerToaster-text', { team: e.team, tournament: e.cup, type: e.type })}`,
				onAccept: () => {
					dispatch(resetDialogue());
				},
			}),
		);
		console.log(e);
	});

	echo.connector.pusher.connection.bind('connected', () => {
		// console.log('connected');
	});
	return (
		<>
			<Navbar />
			<div className="relative">
				<Outlet />
				{loader.show && <Spinner />}
			</div>
		</>
	);
};

export default RootLayout;
